import React, { useMemo } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { createSx } from '../../utils';
import useRive from '../../hooks/useRive';

import logoAnimation from './animations/logo.riv';

const sx = createSx({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'neutral.fixed'
  },
  loader: {
    width: 200,
    height: 200,
  },
});

const Preloader = () => {
  const animation = useMemo(() => {
    const now = new Date();
    const month = now.getMonth(); // 0-11
    const date = now.getDate(); // 1-31
    switch (true) {
      // Dec 20 - Jan 5
      case (month === 11 && date >= 20) || (month === 0 && date <= 5): {
        return 'loading-christmas';
      }
      case (month === 1 && date === 14): {
        return 'loading-valentine';
      }
      default: {
        return 'loading';
      }
    }
  }, []);

  const { RiveComponent, failed } = useRive(
    animation ? { src: logoAnimation, animations: animation, autoplay: true } : null
  );

  return (
    <Box sx={sx.root}>
      <Box sx={sx.loader} role='progressbar' aria-label='Application loading'>
        {failed ? <CircularProgress /> : <RiveComponent />}
      </Box>
    </Box>
  );
};

export default Preloader;
